<template>
  <div class="card card-profile shadow">
    <div class="text-center mt-5">
      <div class="card-profile-image-custom">
        <img src="/img/pages/call.png" width="140" alt="Chamada de startups para incubação"
          title="Chamada de startups para incubação" />
      </div>
      <div class="card-header text-center border-0 mt-7 pb-1">
        <h2 class="text-warning mb-0">{{ call.name }}</h2>
      </div>
    </div>
    <div class="card-body pt-0 pb-1">
      <div class="row">
        <div class="col-12">
          <div class="card-profile-stats text-center pt-1">
            <div>
              <span class="description">Modalidade: </span>
              <span class="heading fw-bold">{{ call.type }}</span>
            </div>
            <div v-if="call.max_startups">
              <span class="description">Máximo de startups: </span>
              <span class="heading">{{ call.max_startups }}</span>
            </div>
            <div v-if="call.link">
              <span class="fw-bold fs-4 btn btn-link p-0 m-0 cursor-pointer heading" title="Abrir edital da chamada"
                @click="openLink(call.link)">Ver edital</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row text-center mb-3" v-if="call.sectors">
        <div class="col-12">
          <h3>
            Setores:
            <span class="font-weight-light">
              <argon-button size="sm" class="cursor-inherit p-2 me-2" v-for="(sector, index) in call.sectors"
                :key="'sector_' + index" :color="bgClasses[index % bgClasses.length]">
                {{ sector }}
              </argon-button>
            </span>
          </h3>
        </div>
      </div>
      <div class="row text-center mt-2">
        <div class="col-12">
          <h3>
            Região:
            <span class="font-weight-light">
              {{ call.region }}
              <badge type="warning" v-if="call.region_limited">
                <i class="fas fa-lock mr-1"></i> inscrições limitadas a startups
                da região
              </badge>
            </span>
          </h3>
          <h3>
            <span v-if="call.end_date">
              Período das aplicações:
              <span class="font-weight-light">
                {{
                  call.start_date ? formatDate(call.start_date, "ll") : "..."
                }}
                até
                {{ formatDate(call.end_date, "ll") }}
              </span>
            </span>
            <span v-else>
              Início das aplicações:
              <span class="font-weight-light">
                {{
                  call.start_date ? formatDate(call.start_date, "ll") : "..."
                }}
                <span v-if="call.start_date"> (fluxo contínuo)</span>
              </span>
            </span>
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1 mt-2 text-center" v-if="call.description || call.observation">
          <hr class="mt-1 mb-4" />
          <p class="small text-left" v-if="call.description">
            <span class="font-weight-bold">&#8226; Descrição:</span>
            {{ call.description }}
          </p>
          <p class="small text-left" v-if="call.observation">
            <span class="font-weight-bold">&#8226; Observações:</span>
            {{ call.observation }}
          </p>
        </div>
      </div>
    </div>
    <slot name="footer">
      <div class="card-footer text-center">
        <argon-alert v-if="call.status === 'closed'" class="mb-0">Inscrições encerradas!</argon-alert>
        <small v-else>
          <i class="fas fa-info-circle mr-1"></i>
          Os dados informados na inscrição serão analisados e utilizados como
          critérios de seleção
          <span v-if="call.type !== 'Olimpíada'">para nosso Programa de {{ call.type }}</span><span v-else>da chamada "{{
            call.name }}"</span></small>.
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: "programa-tab",
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      bgClasses: [
        "info",
        "primary",
        "danger",
        "success",
        "secondary",
        "warning",
        "light",
        "dark"
      ]
    };
  },
  methods: {
    openLink(link) {
      window.open(link, "file-window", "resizable=1,height=750,width=750");
    }
  }
};
</script>

<style scoped>
.cursor-inherit:hover,
.cursor-inherit:active,
.cursor-inherit:focus {
  cursor: inherit;
}

.cursor-pointer {
  cursor: pointer;
}

.card-profile-image-custom img {
  -webkit-transform: translate(-50%, -30%);
  transform: translate(-50%, -30%);
  position: absolute;
  left: 50%;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
}

.card-profile-image-custom img:hover {
  -webkit-transform: translate(-50%, -33%);
  transform: translate(-50%, -33%);
}
</style>
